// CPC — ensure Wallet Standard registry sees CPC Wallet (Explorer often loads after extension registers).

import { useEffect } from 'react';

/** Fire wallet-standard:app-ready so extension re-attaches to dapp-kit registry (same as e2e harness). */
async function pokeWalletStandardRegistry(): Promise<void> {
	try {
		const { getWallets } = await import('@wallet-standard/app');
		getWallets().get();
	} catch {
		// Fallback when @wallet-standard/app is not hoisted: CDN (local dev only).
		try {
			const { getWallets } = await import(
				/* @vite-ignore */
				'https://esm.sh/@wallet-standard/app@1.1.0'
			);
			getWallets().get();
		} catch {
			/* ignore */
		}
	}
}

export function CpcWalletDiscovery() {
	useEffect(() => {
		void pokeWalletStandardRegistry();
		const t = window.setInterval(() => void pokeWalletStandardRegistry(), 2000);
		const onVis = () => {
			if (document.visibilityState === 'visible') void pokeWalletStandardRegistry();
		};
		document.addEventListener('visibilitychange', onVis);
		return () => {
			window.clearInterval(t);
			document.removeEventListener('visibilitychange', onVis);
		};
	}, []);
	return null;
}
